import { Padding } from '@mui/icons-material';
import { alpha, lighten, Theme } from '@mui/material';
import { fr } from 'date-fns/locale';

export const SquareSpaceConnectSx = {
  mainContainer: {
    width: '100%',
    height: '100%',
    backgroundColor: 'var(--color-bg-cream)',
    marginTop: '15px'
  },
  cardSx: {
    width: { xs: 350, sm: 450, md: 460, lg: 460, xl: 520 },
    // boxShadow: 'none',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    backgroundColor: 'var(--color-white)'
  },
  checkCircleOutlineIconSx: {
    color: 'var(--color-secondary)'
  },
  errorTypoSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    margin: '0px 0 0 0',
    color: 'var(--color-text-grey2)'
  },
  accessDeniedErrorTypoSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    margin: '0px 0 0 0',
    color: 'var(--color-text-grey2)'
  },
  accessDeniedErrorSpanSx: {
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  accountConnectedBox: {
    backgroundColor: 'var(--color-success-bg)',
    padding: '8px 24px 8px 24px',
    borderRadius: '40px',
    marginTop: '24px'
  },
  accountConnectedTypo: {
    textAlign: 'center',
    color: 'var(--color-success-dark)'
  },
  accountFailedBox: {
    backgroundColor: '#FFECED',
    padding: '8px 24px 8px 24px',
    borderRadius: '40px',
    marginTop: '24px'
  },
  accountFailedTypo: {
    textAlign: 'center',
    color: 'var(--color-error-bright)'
  },
  successDescTypo: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    marginTop: '16px'
  },
  failDescTypo: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    marginTop: '16px'
  },
  successMessageTypo: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-primary)',
    marginTop: '16px'
  },
  successBtn: {
    padding: '10px 18px 10px 18px',
    borderRadius: '6px ',
    marginTop: '24px'
  }
};

export const messagePageSx = {
  imgSx: {
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  successTypoSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-32)',
    textAlign: 'center',
    color: 'var(--color-success-dark)',
    marginTop: '32px'
  },
  paymentDescSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    marginTop: '20px'
  },
  mainSuccessContainer: {
    maxWidth: '26.5% !important'
  },
  unSuccessfulTypoSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-32)',
    textAlign: 'center',
    color: 'var(--color-error-bright)',
    marginTop: '32px',
    marginBottom: '20px'
  },
  unSuccessfulDescSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)'
  },
  btnBox: {
    display: 'flex',
    gap: '12px'
  },
  getStartedBtn: {
    padding: '10px 18px 10px 18px',
    gap: '8px',
    borderRadius: '6px',
    marginTop: '32px'
  },
  getStartedText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left'
  },
  typography: {
    my: 1,
    textAlign: 'justify',
    fontFamily: 'Inter'
  }
};

export const onBoardingNavbarSx = {
  toolbar: {
    backgroundColor: 'var(--color-white)'
  },
  imgBtnSx: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  spacerBox: {
    flexGrow: 1
  },
  rightSideBoxSx: {
    display: 'flex',
    alignItems: 'center'
  }
};

export const sidebarSx = {
  mainBox: {
    padding: '16px 15px 20px 15px',
    borderRadius: '6px',
    backgroundColor: 'white',
    marginLeft: '15px',
    marginRight: '15px',
    position: 'absolute',
    bottom: '1%'
  },
  unlockAllFeaturesSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    width: 'max-content'
  },
  upgradeDesc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)',
    marginTop: '5px'
  },
  btnBox: {
    display: 'flex',
    gap: '19px',
    marginTop: '16px'
  },
  dismiss: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    cursor: 'pointer'
  },
  upgradeText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-secondary)',
    cursor: 'pointer'
  },
  btnSx: {
    padding: '8px 18px 8px 18px',
    gap: '6px',
    borderRadius: '6px',
    boxShadow: '0px 1px 2px 0px var(--color-text-darkest)0D',
    backgroundColor: 'var(--color-secondary)',
    '&:hover': {
      backgroundColor: 'var(--color-secondary-dark)', // Slightly darker shade for hover
      boxShadow: '0px 2px 4px 0px var(--color-text-darkest)1A' // Slightly elevated shadow on hover
    }
  },
  btnTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  iconBtnSx: {
    height: '16px',
    width: '16px',
    padding: '8px',
    paddingRight: '5px'
  },
  titleBoxSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  sidebarWrapper: (theme: Theme) => ({
    display: {
      xs: 'none',
      lg: 'flex'
    },
    flexDirection: 'column',
    position: 'fixed',
    left: 0,
    top: 0,
    // background: alpha(theme.header.background, 0.95),
    background: 'var(--color-primary)',
    boxShadow: theme.palette.mode === 'dark' ? theme.sidebar.boxShadow : 'none',
    outline: '2px solid rgba(244, 244, 244, 1)'
  }),
  sidebarMainbox: { flex: 1, minHeight: 0, overflow: 'hidden' },
  logo: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  sidebarMenubox: { marginTop: '51px' },
  closeIcon: {
    color: 'var(--color-text-sidebar-icon) !important',
    height: '20px',
    width: '20px'
  },
  sidebarFooter: { textAlign: 'left', flexShrink: 0, marginTop: 'auto' },
  hireUsButton: {
    marginLeft: '18px'
  },
  hireUsBtnTypography: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    color: 'var(--color-white)',
    backgroundColor: 'transparent',
    lineHeight: 1.5,
    // marginLeft: '4px',
    marginRight: '99px',
    marginTop: '2px',
    cursor: 'pointer'
  },
  seoAcademyBtn: {
    marginLeft: '18px'
  },
  seoAcademyBtnTypography: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    color: 'var(--color-white)',
    backgroundColor: 'transparent',
    lineHeight: 1.5,
    // marginLeft: '4px',
    marginRight: '52px',
    marginTop: '2px',
    cursor: 'pointer'
  },
  version: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    color: 'var(--color-white)',
    textAlign: 'center',
    lineHeight: '24px'
  },
  mobileMenuDrawer: (theme: Theme) => ({
    boxShadow: `${theme.sidebar.boxShadow}`
  }),
  mobileLogoBox: { marginLeft: '30px' },
  logoBox: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  sidebarWrapperBox: { flex: 1, minHeight: 0, overflow: 'hidden' }
};

export const upgradeWarningPlanSx = {
  subHeader: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  listBox: {
    paddingLeft: '16px',
    paddingRight: '16px',
    gap: '12px',
    borderRadius: '6px',
    backgroundColor: 'var(--color-bg-light-purple)',
    marginTop: '12px'
  },
  listItem: {
    padding: 0,
    gap: 0
  },
  listItemIcon: {
    minWidth: 'auto',
    marginRight: '12px'
  },
  listItemText: {
    '& .MuiTypography-root': {
      fontFamily: 'Inter',
      fontSize: 'var(--font-size-16)',
      fontWeight: 700,
      lineHeight: 'var(--line-height-24)',
      textAlign: 'left'
    },
    color: 'var(--color-primary)'
  },
  avatarBox: {
    display: 'flex',
    marginTop: '24px'
  },
  joinWith: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  imgSx: {
    width: '100%',
    maxWidth: '224px',
    height: 'auto'
  },
  btnSx: {
    width: '100%'
  },
  titleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 800,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  mainCardBoxSx: {
    padding: '24px',
    background: 'white',
    border: '1px solid lightgray',
    borderRadius: '16px',
    zIndex: 5,
    maxWidth: '36rem'
  },
  mainBgBoxSx: {
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backdropFilter: 'blur(10px)',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      backdropFilter: 'blur(5px)',
      zIndex: 1
    },
    zIndex: 2
  }
};

export const upgradeBoxSx = {
  mainBox: {
    display: 'flex',
    flexDirection: 'column', // Stack children vertically
    justifyContent: 'center', // Center children vertically
    alignItems: 'center', // Center children horizontally
    minHeight: '80vh', // Ensures full viewport height
    width: '100%' // Ensures full width,
  },
  subBox: {
    padding: '24px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for card appearance
    borderRadius: '8px',
    backgroundColor: 'var(--color-white)', // White background for the card
    textAlign: 'center', // Center content inside the card
    minWidth: '300px', // Minimum width for the card
    maxWidth: '750px', // Maximum width for the card
    width: '100%', // Allow the card to be responsive
    margin: '0 16px' // Small horizontal margin for smaller screens
  },
  typoSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'center',
    color: 'var(--color-text-muted)',
    marginBottom: '14px'
  }
};

export const stripeLoaderSx = {
  stripeLoaderBx: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 100px)',
    overflow: 'hidden'
  }
};

export const logoutModelSx = {
  btnSx: {
    padding: '10px 18px 10px 18px',
    gap: '6px',
    borderRadius: '6px',
    height: '40px'
  },
  btnBox: {
    gap: '12px'
  },
  descSx: {
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  }
};

export const commonSx = {
  passwordTooltipTexts: {
    padding: 15,
    fontSize: 13,
    fontWeight: 600,
    fontFamily: 'Inter'
  }
};

export const baseLayoutBoxSx = {
  flex: 1,
  height: '100%'
};

export const overView = {
  spinnerSx: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

// Forgot Component Sxs

export const forgotSx = {
  card: {
    width: { xs: 350, sm: 450, md: 450, lg: 450, xl: 520 },
    boxShadow: 'none'
  },
  resetPasswordTypoSx: {
    fontWeight: 500,
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    lineHeight: 'var(--line-height-22)'
  },
  successMessage: {
    color: 'var(--color-secondary)'
  }
};

// Reset Password component Sxs
export const resetPasswordSx = {
  card: {
    width: { xs: 350, sm: 450, md: 450, lg: 450, xl: 520 },
    boxShadow: 'none'
  },
  showPasswordEyeSx: {
    cursor: 'pointer'
  },
  successMessage: {
    color: 'var(--color-secondary)'
  }
};

// Ststus404 component sx changes - src/content/pages/Status/Status404/index.tsx

export const status404Sx = {
  firstTitleTypography: {
    my: 2,
    lineHeight: 1.2
  },
  description: { mb: 4, lineHeight: 1.2 }
};

// Ststus500 component sx changes - src/content/pages/Status/Status500/index.tsx

export const status500Sx = {
  mainContentHeight: {
    height: '100%'
  },
  titleTypography: {
    my: 2
  },
  descriptionTypography: {
    mb: 4
  },
  goBackBtn: {
    ml: 1
  },
  seoSpaceTypography: {
    my: 2
  },
  pageError: {
    mb: 4
  }
};

// StatusCheck component sx changes - src/content/pages/Status/StatusCheck/index.tsx
export const statusCheckSx = {
  btnImg: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  description: { my: 2, lineHeight: 1.2 },
  longDescription: {
    fontSize: 'var(--font-size-18)',
    lineHeight: 'var(--line-height-36)',
    fontWeight: 500,
    color: 'var(--color-text-tertiary)'
  },
  chatWithUs: {
    cursor: 'pointer',
    textDecoration: 'underline',
    width: 'max-content',
    marginLeft: 'auto',
    marginRight: 'auto'
  }
};

// StatusUpdate component sx changes - src/content/pages/Status/StatusUpdate/index.tsx

export const statusUpdateSx = {
  reportIssueImg: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    padding: '20px' // Add padding to the container for spacing
  },
  reportIssueBtn: { marginLeft: '20px' },
  seoSpaseUp: {
    backgroundColor: '#008329', // Background color for the content box
    color: 'white', // Text color
    padding: '40px', // Padding inside the content box
    textAlign: 'center', // Center text horizontally
    margin: '40px auto' // Center the box and add vertical spacing
  },
  seoSpaseUpTypography: {
    marginBottom: '16px'
  },
  statusPageStyle: {
    color: 'white',
    textDecoration: 'underline'
  },
  seoLogoMargin: {
    marginRight: '20px'
  }
};

// AddonMessagesPage component sx changes - src/content/stripeMessage/components/AddonMessagePage.tsx

export const addonMessagePageSx = {
  successTypography: { my: 1, color: 'green', fontFamily: 'Inter' },
  scansAddedTypography: { mb: 2, fontFamily: 'Inter' },
  moreScanSuccessTypography: { fontFamily: 'Inter' },
  goToDashboardTypography: { fontFamily: 'Inter', width: 200, mt: 5 },
  failureTypography: { my: 1, color: 'red', fontFamily: 'Inter' },
  addOnFailTypography: { mb: 2, fontFamily: 'Inter' },
  goToDashboardContainer: { textAlign: 'center' },
  goToDashboard: { my: 2, fontFamily: 'Inter' }
};

// StatusMaintance component sx changes - src/content/pages/Status/StatusMaintenance/index.tsx

export const statusMaintenanceSx = {
  underMaintenanceTypography: { my: 2, lineHeight: 1.2 },
  maintenanceDescriptionTypography: { mb: 4, lineHeight: 1.2 },
  chatWithUsTypography: {
    cursor: 'pointer',
    textDecoration: 'underline',
    width: 'max-content',
    marginLeft: 'auto',
    marginRight: 'auto'
  }
};

// Sidebarlayout component sx changes - src/layouts/SidebarLayout/index.tsx

export const sidebarLayoutSx = {
  sidebarmainbox: (theme: Theme) => {
    return {
      flex: 1,
      height: '100%',

      '.MuiPageTitle-wrapper': {
        background:
          theme.palette.mode === 'dark'
            ? theme.colors.alpha.trueWhite[5]
            : theme.colors.alpha.white[50],
        marginBottom: `${theme.spacing(4)}`,
        boxShadow:
          theme.palette.mode === 'dark'
            ? `0 1px 0 ${alpha(
                lighten(theme.colors.primary.main, 0.7),
                0.15
              )}, 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 4px -3px ${alpha(
                theme.colors.alpha.black[100],
                0.1
              )}, 0px 5px 12px -4px ${alpha(
                theme.colors.alpha.black[100],
                0.05
              )}`
      }
    };
  },
  containerBox: (theme: Theme) => ({
    position: 'relative',
    zIndex: 5,
    display: 'block',
    flex: 1
  }),
  mainContainerStyle: {
    background: 'var(--color-bg-cream)'
  }
};

// Header component sx changes - src/layouts/SidebarLayout/Header/index.tsx

export const headerSx = {
  headerWrapper: {
    boxShadow: '0px 4px 6px -4px rgba(52, 52, 83, 0.12)' // Bottom-only shadow
  },
  sidebarToggleBox: {
    display: { lg: 'none', xs: 'inline-block' }
  },
  siteAuditModalBtn: { width: '100%', borderRadius: '0px', height: '18.52px' }
};

// InsightsBlankDashboard component sx changes - src/content/seoissues/insightsBlankDashboard.tsx

export const insightsBlankDashboardSx = {
  insightsBlankDashboardBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80vh',
    overflow: 'hidden'
  },
  inProgressTypography: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    color: 'var(--color-text-grey-purple)'
  }
};

// SuspenseLoader component sx changes - src/components/SuspenseLoader/index.tsx

export const suspenseLoaderSx = {
  suspenseLoaderBox: {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
  }
};

// FreePlanOnBoarding component sx changes - src/content/onBoarding/FreePlanOnBoarding.tsx

export const freePlanOnBoardingSx = {
  freePlanOnBoardingBox: {
    backgroundColor: 'var(--color-bg-cream)',
    minHeight: '100vh'
  }
};

export const LocalSeoIconSx = {
  width: '126px',
  height: '26px'
};

export const snackBarCommonSx = {
  successBgColor: 'var(--color-success-bg-ultra)',
  errorBgColor: 'var(--color-error-bg)',
  maxWidth: '667px',
  successBorder: '1px solid var(--color-success-border)',
  errorBorder: '1px solid var(--color-error-red)',
  topSpacing: { marginTop: '2.8rem' },
  iconSize: {
    width: '40px',
    height: '27px'
  }
};

export const subscriptionPaymentFailedSx = {
  mainBox: {
    border: '1px solid var(--color-error-alt)',
    backgroundColor: 'var(--color-error-bg)',
    gap: '12px',
    alignItems: { xs: 'flex-start', sm: 'center' },
    borderRadius: '8px',
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    marginBottom: '1rem',
    padding: '0.5rem'
  },
  headerText: {
    fontFamily: 'Inter',
    fontSize: { xs: '14px', sm: '16px' },
    fontWeight: 800,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    marginBottom: '4px'
  },
  desc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left'
  },
  buttonBox: {
    flexShrink: 0,
    width: { xs: '100%', sm: 'auto' },
    display: 'flex',
    justifyContent: { xs: 'flex-end', sm: 'unset' }
  },
  button: {
    width: { xs: '100%', sm: 'auto' },
    height: 10,
    fontFamily: 'Inter',
    py: 2.5,
    borderRadius: 0.6,
    marginRight: { xs: 0, sm: '5px' },
    backgroundColor: 'var(--color-error-alt)',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: 'var(--color-error-alt)'
    }
  },
  buttonText: {
    color: 'var(--color-primary)',
    fontWeight: 400
  }
};

export const siteDeletedWarningSx = {
  mainBox: {
    border: '1px solid var(--color-warning-border, #FD853A)',
    backgroundColor: 'var(--color-warning-bg, #FFF6ED)',
    gap: '12px',
    alignItems: { xs: 'flex-start', sm: 'center' },
    borderRadius: '8px',
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    marginBottom: '1rem',
    padding: '0.5rem 1.25rem'
  },
  headerText: {
    fontFamily: 'Inter',
    fontSize: { xs: '14px', sm: '16px' },
    fontWeight: 800,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    marginBottom: '4px'
  },
  desc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary, #344054)'
  }
};
